/* eslint-disable */
import 'jquery.cookie';

const sbjs = require('../../plugins/sourcebuster');

sbjs.init({ domain: 'travelata.ru' });

/**
 * Generates a UUID v4
 */
const generateUUID = () => {
  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return `tl_${Date.now()}_${Math.random().toString(36).substring(2)}`;
};

/**
 * Extracts UTM parameters from current page URL
 */
const getUtmParamsFromUrl = () => {
	const urlParams = new URLSearchParams(window.location.search);
	return {
		utm_source: urlParams.get('utm_source'),
		utm_medium: urlParams.get('utm_medium'),
		utm_campaign: urlParams.get('utm_campaign'),
		utm_content: urlParams.get('utm_content'),
		utm_term: urlParams.get('utm_term')
	};
};

/**
 * Generates AppMetrica URL parameters
 * @param {string} bannerName
 * @param {string} partner
 * @returns {string}
 */
const appmetricaParams = (bannerName = null, partner = 'desktop') => {
	const clientUuid = $.cookie('clientUuid');

	const urlUtmParams = getUtmParamsFromUrl();
	const sbData = sbjs.get && sbjs.get.current ? sbjs.get.current : {};
	const sbSrc = sbData.src || '';
	const sbMdm = sbData.mdm || '';
	const sbCmp = sbData.cmp || '';
	const sbCnt = sbData.cnt || '';
	const sbTrm = sbData.trm || '';

	const urlParams = {
		click_id: generateUUID(),
		rnd: Math.random(),
		partner: partner
	};

	if (bannerName) {
		urlParams.utm_source = bannerName;
	}

	if (urlUtmParams.utm_medium) {
		urlParams.utm_medium = urlUtmParams.utm_medium;
	} else if (sbSrc || sbMdm) {
		urlParams.utm_medium = `${sbSrc}|${sbMdm}`;
	}

	if (urlUtmParams.utm_campaign) {
		urlParams.utm_campaign = urlUtmParams.utm_campaign;
	} else if (sbCmp) {
		urlParams.utm_campaign = sbCmp;
	}

	if (urlUtmParams.utm_content) {
		urlParams.utm_content = urlUtmParams.utm_content;
	} else if (sbCnt) {
		urlParams.utm_content = sbCnt;
	}

	if (urlUtmParams.utm_term) {
		urlParams.utm_term = urlUtmParams.utm_term;
	} else if (sbTrm) {
		urlParams.utm_term = sbTrm;
	}

	if (clientUuid) {
		urlParams.client_uuid = clientUuid;
	}

	return $.param(urlParams);
};

export default appmetricaParams;
